import React, { createContext, useContext } from 'react';

export interface ScreenHeaderHeightValue {
  /** ScreenLayout's own effectiveHeaderHeight (the real, measured height of
   * the app-level nav bar on web) — lets FormHeader position itself
   * directly beneath it without re-measuring via measureInWindow, which
   * raced the app header's own height settling and could land FormHeader
   * partially underneath it before the real height arrived. */
  headerHeight: number;
  /** True when ScreenLayout received this FormHeader via its `formHeader`
   * prop (rendered as a real flex sibling of the scrollable content, never
   * nested inside it) rather than as part of `children`. In that mode
   * FormHeader is already correctly placed by ordinary flex layout and
   * should render as plain in-flow content — position:fixed there would be
   * redundant, and re-adds the measurement complexity this prop exists to
   * avoid. Screens not yet migrated to `formHeader` keep the fixed-position
   * fallback (see FormHeader.tsx). */
  isPinnedByLayout: boolean;
}

const defaultValue: ScreenHeaderHeightValue = { headerHeight: 0, isPinnedByLayout: false };

const ScreenHeaderHeightContext = createContext<ScreenHeaderHeightValue>(defaultValue);

export const ScreenHeaderHeightProvider = ScreenHeaderHeightContext.Provider;

export const useScreenHeaderHeight = () => useContext(ScreenHeaderHeightContext);
